import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';
import Badge from './ui/Badge';
import SafeIcon from '../common/SafeIcon';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      className="group bg-white rounded-3xl border-2 border-ink-navy overflow-hidden flex flex-col h-full shadow-[8px_8px_0_0_#1e1b4b] hover:shadow-[12px_12px_0_0_#1e1b4b] transition-all duration-300"
    >
      <div className="relative h-56 overflow-hidden bg-slate-50 border-b-2 border-ink-navy">
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4 flex flex-col gap-2">
          <Badge variant="yellow">Ages {product.ageRange}</Badge>
          {product.isBundle && <Badge variant="blue">Value Bundle</Badge>}
        </div>
        <button className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur rounded-full border-2 border-ink-navy flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-lemon-yellow">
          <SafeIcon name="Heart" className="text-ink-navy" />
        </button>
      </div>
      
      <div className="p-6 flex flex-col flex-grow">
        <div className="text-[10px] font-black uppercase tracking-widest text-sky-blue mb-1">
          {product.category}
        </div>
        <h3 className="font-extrabold text-xl text-ink-navy leading-tight mb-2 group-hover:text-sky-blue transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-slate-500 mb-6 line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        
        <div className="mt-auto flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-xs font-bold text-slate-400 line-through leading-none">$ {(product.price * 1.2).toFixed(2)}</span>
            <span className="font-black text-2xl text-ink-navy leading-none mt-1">${product.price.toFixed(2)}</span>
          </div>
          <Button 
            variant="primary" 
            size="sm"
            className="rounded-xl"
            onClick={() => addToCart(product)}
          >
            <SafeIcon name="Plus" className="mr-1" />
            Add
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;